// extracted by mini-css-extract-plugin
var _1 = "GGH6VCOwaRdz0A3pCDCg";
var _2 = "DvsUNiOE1s9tVEDX806r";
var _3 = "vbHMWF_D7RGl5DZzG8kF";
var _4 = "PBbfJ24u5X1atmU0TZuS";
export { _1 as "box", _2 as "content", _3 as "overlay", _4 as "wipe" }
